import React from "react"
import EmptyDataMessage from "../../../../components/molecules/EmptyDataPieChartMessage.molecule"
import GridContainer from "../../../../components/layouts/containers/GridContainer.container"
import GridItem from "../../../../components/layouts/containers/GridItem.container"
import InputNumberForm from "../../../../components/molecules/InputNumberForm.molecule"

const PointsPerMemberInputs = ({
  teamMembers = [],
  setFormData = () => {},
  minPoints = 0,
  maxPoints = 255,
}) => {
  if (teamMembers.length === 0) {
    return (
      <EmptyDataMessage
        title="Sin participantes"
        message="Selecciona al menos un participante para asignar puntos."
        titleClassName="my-1"
        height="150px"
      />
    )
  }
  return (
    <GridContainer>
      {teamMembers.map((teamMember) => (
        <GridItem key={teamMember?.teamMemberId} md={6}>
          <InputNumberForm
            label={`${teamMember?.teamMemberNameTag} - ${teamMember?.teamMemberName} ${teamMember?.teamMemberLastName}`}
            className="mb-3"
            labelClassName="mb-2"
            value={teamMember?.points || 0}
            onChange={(e) => {
              setFormData((prev) => ({
                ...prev,
                teamMembers: prev.teamMembers.map((member) => {
                  if (member.teamMemberId !== teamMember.teamMemberId) {
                    return member
                  }
                  const newValue = parseInt(e.value, 10)
                  if (isNaN(newValue)) return member
                  if (newValue < minPoints || newValue > maxPoints) {
                    return {
                      ...member,
                      points: newValue < minPoints ? minPoints : maxPoints,
                    }
                  }
                  return {
                    ...member,
                    points: newValue,
                  }
                }),
              }))
            }}
            min={minPoints}
            max={maxPoints}
            maxLength={maxPoints.toString().length}
            placeholder="Puntos asignados"
            showButtons
            step={1}
          />
        </GridItem>
      ))}
    </GridContainer>
  )
}

export default PointsPerMemberInputs
